import { createAction } from "redux-actions";

import {
  GET_SCORING_RESULTS_REPORT_ENTRIES,
  GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT,
  SET_SCORING_RESULTS_REPORT_ENTRIES_CURRENT_PAGE,
  SET_SCORING_RESULTS_REPORT_ENTRIES_FILTERS,
  CLEAR_SCORING_RESULTS_REPORT,
  SET_SCORING_RESULTS_ITEMS_PER_PAGE,
  SET_SCORING_RESULTS_NO_ENTRIES_MESSAGE,
} from "../../types";

import createAsyncActions from "../../../../utilities/createAsyncActions";

export const {
  getScoringResultsReportEntries,
  getScoringResultsReportEntriesPending,
  getScoringResultsReportEntriesFulfilled,
  getScoringResultsReportEntriesRejected,
} = createAsyncActions(
  GET_SCORING_RESULTS_REPORT_ENTRIES,
  "getScoringResultsReportEntries"
);

export const {
  getScoringResultsReportEntriesCount,
  getScoringResultsReportEntriesCountPending,
  getScoringResultsReportEntriesCountFulfilled,
  getScoringResultsReportEntriesCountRejected,
} = createAsyncActions(
  GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT,
  "getScoringResultsReportEntriesCount"
);

export const setScoringResultsReportEntriesCurrentPage = createAction(
  SET_SCORING_RESULTS_REPORT_ENTRIES_CURRENT_PAGE
);
export const setSearchFilters = createAction(
  SET_SCORING_RESULTS_REPORT_ENTRIES_FILTERS
);
export const clearScoringResultsReport = createAction(
  CLEAR_SCORING_RESULTS_REPORT
);
export const setScoringResultsItemsPerPage = createAction(
  SET_SCORING_RESULTS_ITEMS_PER_PAGE
);
export const setScoringResultsNoEntriesMessage = createAction(
  SET_SCORING_RESULTS_NO_ENTRIES_MESSAGE
);



// WEBPACK FOOTER //
// ./src/features/reports/actions/scoring-results/getScoringResultsReportEntriesActions.js